import { Container } from "@needle-di/core";

export const container = new Container();
